import axios from "axios";
import { UserConfig } from "./user_config";

const isDebug = process.env.REACT_APP_DEBUG === "true";
const backendEndPoint = isDebug ? process.env.REACT_APP_BACKEND_ENDPOINT_DEBUG : process.env.REACT_APP_BACKEND_ENDPOINT;
const backendPoint = isDebug ? process.env.REACT_APP_BACKEND_PORT_DEBUG : process.env.REACT_APP_BACKEND_PORT;

const axiosApiInstance = axios.create();
let httpEndpoint = `${backendEndPoint}`;
if (backendPoint.length > 0) {
  httpEndpoint += `:${backendPoint}`;
}
let wsEndpoint = `${backendEndPoint}`;
if (backendPoint.length > 0) {
  wsEndpoint += `:${backendPoint}`;
}
const userConfig = new UserConfig();

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    config.headers = {
      //   Authorization: `Bearer ${getAccessToken()}`,
      // Accept: "application/json",
      // "Content-Type": "application/x-www-form-urlencoded",
      // "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      //   const accessToken = await refreshAccessToken(getAccessToken());
      //   console.log("accessToken");
      //   console.log(accessToken);
      //   axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

const downloadCorrectGestureFile = async ({ filename }) => {
  try {
    // const url = `${httpEndpoint}/video/${filename}`;
    const url = `/video/${filename}`;
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const jsonData = await response.json();
    return jsonData;
    // Perform any further operations with the JSON data (JavaScript object)
  } catch (error) {
    console.error("Error:", error);
  }
};

const getExercises = async () => {
  try {
    const response = axiosApiInstance.get(`${httpEndpoint}/api/v1/exercise/exercises`, {
      params: {},
    });
    return (await response).data;
  } catch (error) {
    console.error("Error:", error);
  }
};

const postExercise = async ({ exerciseDetail }) => {
  try {
    const response = axiosApiInstance.post(`${httpEndpoint}/api/v1/exercise/exercise`, {
      exercise_dict: exerciseDetail,
    });
    return (await response).data;
  } catch (error) {
    console.error("Error:", error);
  }
};

const uploadFile = async ({ file, exercise_id, upload_type }) => {
  var formData = new FormData();
  formData.append("file", file);
  formData.append("exercise_id", exercise_id);
  formData.append("upload_type", upload_type);
  const response = axiosApiInstance.post(`${httpEndpoint}/api/v1/exercise/upload`, formData);
  return (await response).data;
};

const getExerciseUrl = async ({ exercise_id, upload_type }) => {
  try {
    const response = axiosApiInstance.get(`${httpEndpoint}/api/v1/exercise/exercise_url`, {
      params: { exercise_id, upload_type },
    });
    return (await response).data;
  } catch (error) {
    console.error("Error:", error);
  }
};

const loggingApi = async ({ message }) => {
  try {
    const response = axiosApiInstance.post(`https://survey.reality-connect.tech/api/v1/logging/logging`, {
      product: "smart_mirror_frontend",
      message,
    });
    return (await response).data;
  } catch (error) {
    return null;
  }
};

export { downloadCorrectGestureFile, getExercises, getExerciseUrl, httpEndpoint, loggingApi, postExercise, uploadFile };
